import {FINANCIAL_IDS} from "@/enums/financials/financialIds";
import { spanishFinancials } from "@/enums/financials/financialNationality";

/**
 * Financeiras que aplicam despesas de legalização
 */
export const LEGAL_TAX_FINANCIALS = [
    FINANCIAL_IDS.CREDIBOM,
    FINANCIAL_IDS.BPI,
    FINANCIAL_IDS.SANTANDER_CONSUMER,
    FINANCIAL_IDS.CETELEM,
    FINANCIAL_IDS.COFIDIS_PT
];

/**
 * Verifica se a financeira aplica despesas de legalização
 * @param {number} financialId - ID da financeira
 * @returns {boolean}
 */
export function hasLegalTax(financialId) {
    return LEGAL_TAX_FINANCIALS.includes(Number(financialId));
}

/**
 * Determina se deve aplicar taxa legal baseado nas regras de negócio:
 * - Cetelem (ID 8): sempre aplica
 * - Cofidis (ID 19): aplica apenas para veículos novos
 * - Outras financeiras: aplicam apenas para veículos usados
 * 
 * @param {number} financialId - ID da financeira
 * @param {number} vehicleConditionId - ID da condição do veículo (1=Novo, 2=Usado)
 * @returns {boolean}
 */
export function shouldApplyLegalTaxByCondition(financialId, vehicleConditionId) {
    return (vehicleConditionId === 2 || financialId == FINANCIAL_IDS.CETELEM || financialId == FINANCIAL_IDS.COFIDIS_PT);
}

export function isCofidis(financialId) {
    return financialId == FINANCIAL_IDS.COFIDIS_PT;
}

export function isCredibom(financialId) {
    return financialId == FINANCIAL_IDS.CREDIBOM;
}

export const NOTARY_TRANSFER_FEES_FINANCIALS = [
    FINANCIAL_IDS.COFIDIS_PT,
    FINANCIAL_IDS.CREDIBOM,
    // nova financeira: basta adicionar aqui
];

export function hasNotaryTransferFees(financialId) {
    return NOTARY_TRANSFER_FEES_FINANCIALS.includes(Number(financialId));
}

export const NOTARY_TRANSFER_FEE_OPTIONS = {
    [FINANCIAL_IDS.COFIDIS_PT]: [
        "Suportado Parceiro",
        "Cliente - abertura ATM",
        "Cliente - Financiado",
    ],
    [FINANCIAL_IDS.CREDIBOM]: [
        "Suportado Parceiro",
        "Suportado pela Financeira",
    ],
    // nova financeira: basta adicionar aqui
};

export const NOTARY_TRANSFER_FEE_CONFIG = {
    [FINANCIAL_IDS.COFIDIS_PT]: {
        options: [
            "Suportado Parceiro",
            "Cliente - abertura ATM",
            "Cliente - Financiado",
        ],
    },
    [FINANCIAL_IDS.CREDIBOM]: {
        options: [
            "Suportado Parceiro",
            "Suportado pela Financeira",
        ],
        fixedValue: "Suportado Parceiro",
        fixedValueByCompany: {
            28: "Suportado pela Financeira",
        },
    },
};

export function resolveNotaryTransferFeeValue(financialId, selectedValue, companyId) {
  const config = NOTARY_TRANSFER_FEE_CONFIG[Number(financialId)];

  if (!config) return "";

  let value = selectedValue;

  if (config.fixedValue != null) {
    if (companyId == null || companyId === "") return "";

    value =
      config.fixedValueByCompany?.[Number(companyId)] ??
      config.fixedValue;
  }

  return config.options.includes(value) ? value : "";
}

export function isSantanderConsumerES(financialId) {
    return financialId == FINANCIAL_IDS.SANTANDER_CONSUMER_ES;
}

export { spanishFinancials };